/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2022 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021-2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 * Copyright 2023-2025 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// Views
import Software from './views/softwareList';
import About from './views/about';
import DataPolicy from './views/datapolicy';
import TvView from './components/tvView/tvView';
import Mixed from './views/mixedList';
import Machines from './views/machineList';
import FaultyList from './views/faultyMachineList';
// Components
import Header from './components/header/header';
import Footer from './components/footer/footer';
import MQTTComponent from './utilities/MQTTComponent';
import URLs from './utilities/URLs';
import SubscriptionComponent from './utilities/SubscriptionComponent';
import WorldMap from './components/worldMap/worldMap';
import SoftwareDetailView from './views/softwareDetail';
import Tabs from './components/tabs/tabWrapper';
// Store
import { store } from './redux/store';
import { updateMachines, updateFaultyMachines, updateOnlineMachines } from './redux/reducers/machines';
import { connect } from 'react-redux';
import { getFairs, getMachines } from './redux/selectors';
import MqttTopics from './utilities/MqttTopics';
import MQTTWebsocket from 'utilities/mqtt/MQTTWebsocket';
import SubscribedDetail from 'components/SubscribedDetail';

import './styles/styles.scss';
import ENVs from 'utilities/ENVs';
import { isTopicMatch } from 'utilities/mqtt/MQTTWebsocket';
import { getAntiforgeryToken } from 'api/antiforgery';
class App extends React.Component {
  constructor(props) {
    super(props);
    this.brokerUrl = URLs.MqttBrokerUrl();
    this.state = {
      machineIdentification: null,
      fairs: {},
      machines: [],
      startReceivingMqttMessages: true,
      selectedTab: '',
      ws: new MQTTWebsocket(this.brokerUrl, ENVs.MqttUsername(), ENVs.MqttPassword(), 0)
    };
    getAntiforgeryToken();
  }

  updateMachineStore = (newMachines, topic) => {
    const tps = topic.split('/');
    const specification = tps[tps.length - 1];
    store.dispatch(updateMachines(newMachines, specification));
  };

  updateOnlineMachinesStore = (onlineMachines, topic) => {
    if (topic != MqttTopics.MachinesOnline()) {
      console.error('Invalid Topic: ', topic);
    }
    store.dispatch(updateOnlineMachines(onlineMachines));
  };

  updateFaultyMachineStore = (newFaultyMachines, topic) => {
    if (!isTopicMatch(MqttTopics.FaultyList('errors'), topic)) {
      console.error('Invalid Topic: ', topic);
    }
    store.dispatch(updateFaultyMachines(newFaultyMachines, topic));
  };

  render() {
    return (
      <MQTTComponent ws={this.state.ws}>
        {/* <SubscriptionComponent {...this.props} topic={MqttTopics.List('#')} subscriptionCallback={this.updateMachineStore} startReceivingData={this.state.startReceivingMqttMessages}>
        </SubscriptionComponent> */}
        <SubscriptionComponent {...this.props} topic={MqttTopics.MachinesOnline()} subscriptionCallback={this.updateOnlineMachinesStore} startReceivingData={this.state.startReceivingMqttMessages}>
        </SubscriptionComponent>
        <SubscriptionComponent {...this.props} topic={MqttTopics.FaultyList('errors')} subscriptionCallback={this.updateFaultyMachineStore} startReceivingData={this.state.startReceivingMqttMessages}>
        </SubscriptionComponent>
        <Router>
          <Routes>
            <Route path="tvview/:fair" element={
              <TvView />
            } />
            <Route path="tvview/:fair/:slide" element={
              <TvView />
            } />
            <Route path="tvview/:fair/:slide/:machine" element={
              <TvView />
            } />
            <Route path=":fairTag/:typeId/:machine" element={
              <SubscribedDetail />
            } />
            <Route path="software/:fair/:software" element={
              <main className="footer-wrapper">
                <SoftwareDetailView />
              </main>
            } />
            <Route path=":selected/:fair" element={
              <main className="footer-wraper">
                <Header />
                <Tabs default="machines"
                  paramToAppendToLinks="fair"
                  tabElements={
                    [
                      {
                        id: 'overview',
                        node: <Mixed />,
                        link: '/overview'
                      },
                      {
                        icon: 'icon-machines',
                        id: 'machines',
                        node: <Machines />,
                        link: '/machines'
                      },
                      {
                        icon: 'icon-software',
                        id: 'software',
                        node: <Software />,
                        link: '/software'
                      }
                    ]
                  }
                />
                <Footer />
              </main>
            } />
            <Route path="about" element={
              <main className="footer-wrapper">
                <Header />
                <About />
                <Footer />
              </main>
            } />
            <Route path="debug" element={
              <main className="footer-wrapper">
                <Header />
                <FaultyList />
                <Footer />
              </main>
            } />
            <Route path="data-policy" element={
              <main className="footer-wrapper">
                <Header />
                <DataPolicy />
                <Footer />
              </main>
            } />
            <Route path="/" element={
              <><Header fixed overview />
                <div className="view-map">
                  <WorldMap />
                </div>
                <Footer fixed /></>
            } />
          </Routes>
        </Router>
      </MQTTComponent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    machines: getMachines(state),
    fairs: getFairs(state)
  };
};

export default connect(mapStateToProps)(App);
